'use client';
import { IRepository } from '@/types';
import useGatedAccessPolicy from '@/hooks/useGatedAccessPolicy';
import { TAccessFormValues } from '@/lib/gatedAccess/gatedAccessUserApi';
import { createAccessUser } from './createAccessUserAction';
import { useRouter } from 'next/navigation';
import Button from '@/ui/Button';
// import useOxenSession from '@/hooks/useOxenSession';
import ExpandableContainer from '@/ui/ExpandableContainer';
import MarkdownViewer from '@/components/MarkdownViewer';
import { Stack, Row } from '@/ui/primatives';
import * as Icon from '@/ui/Icon';
import DynamicForm from '@/components/DynamicForm';
import { colors } from '@/styles';

const AccessRequest: React.FC<{
  repository: IRepository;
}> = ({ repository }) => {
  const router = useRouter();
  // const { currentUser } = useOxenSession();
  const { gatedAccessPolicy } = useGatedAccessPolicy({ repository });

  const submit = async (formValues?: TAccessFormValues) => {
    if (!gatedAccessPolicy) {
      return;
    }
    const response = await createAccessUser({ repository, gatedAccessPolicy, formValues });
    if (response.status === 'success') {
      router.refresh();
    }
    console.log('AccessRequest Failed > response', response);
  };


  return (
    <ExpandableContainer>
      <Row gap={10} alignItems="center" style={{ borderBottom: `1px solid ${colors.secondary.lightGray3}`, paddingBottom: 10 }}>
        <Icon.AccessGate height={20} width={20} />
        <h6>{gatedAccessPolicy?.intro_title}</h6>
      </Row>
      <Stack gap={0} style={{ paddingTop: 10 }}>
        {gatedAccessPolicy?.intro_content && (
          <MarkdownViewer children={gatedAccessPolicy.intro_content} />
        )}
        <p style={{ borderTop: `1px solid ${colors.secondary.lightGray3}`, paddingTop: 10 }}>{gatedAccessPolicy?.license_statement}</p>
        {gatedAccessPolicy?.access_form_schema ? (
          <DynamicForm
            schema={gatedAccessPolicy.access_form_schema}
            submitText="Accept"
            onSubmit={submit}
          />
        ) : (
          <Button.Black small onClick={() => submit()}>
            Accept
          </Button.Black>
        )}
      </Stack>
    </ExpandableContainer>
  );
};

export default AccessRequest;
